import ExhibitDetail from "pages/Incident/IncidentDetail/modals/ExhibitDetail";
import { FC, useState } from "react";
import {
  CaseCreation,
  Exhibit,
  Reporter,
  Suspect,
  Victim,
  Witness,
  WitnessDefendants,
} from "types";
import { uploadIcon, viewIcon } from "utils/constant";
import WitnessDefendantForm from "./WitnessDefendantForm";
import DocumentViewerModal from "components/DocumentViewer";

type Props = {
  caseData: CaseCreation;
  caseRelatedParties: {
    suspects: Suspect[];
    witnesses: Witness[];
    victims: Victim[];
    reporters: Reporter[];
    exhibits: Exhibit[];
  };
  fetchData: () => void;
  fetchRelatedParties: () => void;
  isCoordinator?: boolean;
  isRegistrar?: boolean;
  isProsecutor?: boolean;
};

const ExibitList: FC<Props> = ({
  caseData,
  caseRelatedParties,
  fetchData,
  fetchRelatedParties,
  isCoordinator = false,
  isRegistrar = false,
  isProsecutor = false,
}) => {
  const [openForm, setOpenForm] = useState(false);
  const [selectedData, setSelectedData] = useState<WitnessDefendants>();
  const [isOpenDetail, setIsOpenDetail] = useState(false);
  const [selectedExhibit, setSelectedEvidence] = useState<Exhibit>();

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-2 h-8 bg-red-600 rounded-full"></div>
          <h3 className="text-lg font-semibold text-gray-900">Exhibits</h3>
        </div>

        {caseRelatedParties?.exhibits &&
        Array.isArray(caseRelatedParties.exhibits) &&
        caseRelatedParties.exhibits.length > 0 ? (
          <div className="space-y-4">
            {caseRelatedParties.exhibits.map((exhibit: any, index: number) => (
              <div
                key={index}
                className="border border-gray-200 rounded-lg p-4 hover:border-gray-300 transition-colors"
              >
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center">
                      <span className="text-blue-600">📁</span>
                    </div>
                    <div>
                      <h4 className="font-medium text-gray-900">
                        {exhibit?.tool_type}
                      </h4>
                      <p className="text-sm text-gray-600">
                        Collected by: {exhibit?.collected_by}
                      </p>
                    </div>
                  </div>

                  <button
                    onClick={() => {
                      setSelectedEvidence(exhibit);
                      setIsOpenDetail(true);
                    }}
                    className="px-4 py-2 text-sm text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                  >
                    View Details
                  </button>
                </div>

                <div className="mt-4">
                  <DocumentViewerModal
                    documents={(exhibit?.documents || []) as any}
                    baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal-entity/exhibit-documents/document/document`}
                    layout="list"
                    label="Exhibit Documents"
                    hideEmptyFile={true}
                  />
                </div>

                {exhibit?.prosecution_decision_type && (
                  <div className="mt-4 p-3 bg-gray-50 rounded-lg">
                    <div className="flex items-center gap-4">
                      <div>
                        <span className="text-xs font-medium text-gray-500">
                          Prosecutor Decision
                        </span>
                        <p className="text-sm font-medium text-gray-900">
                          {exhibit.prosecution_decision_type}
                        </p>
                      </div>
                      {exhibit?.court_decision_type && (
                        <div>
                          <span className="text-xs font-medium text-gray-500">
                            Court Decision
                          </span>
                          <p className="text-sm font-medium text-gray-900">
                            {exhibit.court_decision_type}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8 text-gray-500">
            No exhibits found
          </div>
        )}
      </div>

      {/* Modals */}
      {openForm && caseRelatedParties && caseData && (
        <WitnessDefendantForm
          caseData={caseData}
          action={"add"}
          selectedData={selectedData}
          caseRelatedParties={caseRelatedParties}
          onClose={(reload) => {
            setOpenForm(false);
            setSelectedData(undefined);
            if (reload) fetchRelatedParties();
          }}
        />
      )}

      {isOpenDetail && (
        <ExhibitDetail
          exhibit={selectedExhibit}
          isOpen={isOpenDetail}
          onClose={(reload) => {
            setIsOpenDetail(false);
            if (reload) fetchRelatedParties();
          }}
        />
      )}
    </div>
  );
};

export default ExibitList;
